const $ = window.jQuery;
const $window = window.$window || $(window);

/**
 * Intercept clicks on any anchor tag and if the anchor is linking to an on page ID, animate the scroll to the targeted
 * element.
 *
 * This only works if the href contains a value beginning with '#'. e.g; #about-section. You can modify this behaviour
 * by changing the this.link_is_targeting_on_page_anchor() method.
 *
 * If the clicked element has a `data-toggle=xxx` attribute, it won't be handled. You can modify this behaviour by
 * changing the this.is_excluded() method.
 */
const AnimateOnPageLinks = {
  duration: 800,
  offset: -100,

  init() {
    /* ANCHORING
================================================ */
    $('a[href^="#"]').click(function (e) {
      e.preventDefault()
    })
    // SMOOTH SCROLL BUTTONS
    $(document).on('click', 'a[href^="#"]', function (e) {
      e.preventDefault()
      var target = this.hash
      var $target = $(target)
      $('html, body')
        .stop()
        .animate(
          {
            scrollTop: $target.offset().top - 0,
          },
          1000
        )
    })
  },


};

export default AnimateOnPageLinks;
